__turbopack_context__.v({
  "agebadge": "Home-module__gYy5uW__agebadge",
  "black": "Home-module__gYy5uW__black",
  "btn-get-started": "Home-module__gYy5uW__btn-get-started",
  "btn-watch-video": "Home-module__gYy5uW__btn-watch-video",
  "circle": "Home-module__gYy5uW__circle",
  "container": "Home-module__gYy5uW__container",
  "discovercard": "Home-module__gYy5uW__discovercard",
  "greybackgroundsection": "Home-module__gYy5uW__greybackgroundsection",
  "hero": "Home-module__gYy5uW__hero",
  "heroImg": "Home-module__gYy5uW__heroImg",
  "mobilefont": "Home-module__gYy5uW__mobilefont",
  "name": "Home-module__gYy5uW__name",
  "thumbnails": "Home-module__gYy5uW__thumbnails",
  "title": "Home-module__gYy5uW__title",
});
